var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 42,
    viewBox: "0 0 85 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 21C85 9.4017 75.4864 0 63.75 0H21.25C9.51363 0 0 9.4017 0 21C0 32.5983 9.51363 42 21.25 42H63.75C75.4864 42 85 32.5983 85 21ZM73.3125 21C73.3125 23.7848 72.1931 26.4555 70.2005 28.4246C68.2079 30.3938 65.5054 31.5 62.6875 31.5C59.8696 31.5 57.1671 30.3938 55.1745 28.4246C53.1819 26.4555 52.0625 23.7848 52.0625 21C52.0625 18.2152 53.1819 15.5445 55.1745 13.5754C57.1671 11.6062 59.8696 10.5 62.6875 10.5C65.5054 10.5 68.2079 11.6062 70.2005 13.5754C72.1931 15.5445 73.3125 18.2152 73.3125 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOn);
export default __webpack_public_path__ + "static/media/toggle_on.c96992f0276b7b59748b7d08664c0824.svg";
export { ForwardRef as ReactComponent };